@if (mediaImage()) {
    <picture>
        @for (imgSrc of imageSources(); track imgSrc.media + imgSrc.sourceSet) {
            <source [media]="imgSrc.media" [srcset]="imgSrc.sourceSet" />
        }
        <img
            [src]="src()"
            [attr.srcset]="srcset() || null"
            [alt]="resolvedAlt()"
            (load)="onLoaded()"
            [attr.fetchpriority]="fetchPriority()"
            [attr.itemprop]="itemprop()"
            [style.object-position]="objectPosition()" />
    </picture>
}
<ng-content></ng-content>
